<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d8e53NaN">
</p><p class="bkt" id="d7e71"><b>Violet Path </b></p>
<p class="bkt1" id="d7e121">by<br/>Olivia Lodise </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lodi_9781937084325_epub_c1_r1.vue?bb1369ea